import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { UsersService } from 'data/services';
import userProfileStore from 'data/stores/UserProfileStore';
import { useTranslation } from 'react-i18next';
import { toastify } from 'utils/toastify';

const UpdatePasswordModal = observer((props) => {
    const { t } = useTranslation();
    const user = userProfileStore.user;
    const [isFormSubmitting, setFormSubmitting] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);


    const toggleVisibility = (e) => {
        setPasswordVisible((previousVisibility) => !previousVisibility)
    }

    const {
        register,
        formState: { errors },
        handleSubmit,
        reset,
        setError,
        clearErrors
    } = useForm();

    const onSubmit = async (data) => {
        if (data.password === data.password2) {
            setFormSubmitting(true);
            const response = await UsersService.edit({ ...user, oldPassword: data.oldPassword, password: data.password });
            setFormSubmitting(false);
            if (response.isSuccess) {
                toastify.success(t("SUCCESSFULLY_UPDATED_PASSWORD"));
                reset();
                props.onDiscard();
            } else if (response.error === "Current password is not valid") {
                const err = {
                    message: t("OLD_PASSWORD_NOT_SAME"),
                    id: 1
                }
                setError('oldPassword', err)
            } else if (response.error === "New password cannot be the same as current password") {
                const err = {
                    message: t("NEW_PASSWORD_SAME_AS_CURRENT"),
                    id: 2
                }
                setError('password', err)
                setError('password2', err)
            }
            else {
                toastify.error(t("PASSWORD_ERROR_UPDATE"));
            }
        }
        else {
            toastify.error(t("CONFIRM_PASSWORD_ERROR"));
            clearErrors('password2')
            setError('password2NotSame', t("CONFIRM_PASSWORD_NOT_SAME_AS_NEW_PASSWORD"))
        }
    }
    useEffect(() => {
        var modal = document.getElementsByClassName('modal-size')
        if (errors && (errors.oldPassword || errors.password || errors.password2)) {
            Array.from(modal).forEach(x => {
                x.className = 'react-responsive-modal-modal modal-size-error'
            })
        } else {
            Array.from(modal).forEach(x => {
                x.className = 'react-responsive-modal-modal modal-size'
            })
        }
    }, [errors])
    return (
        <>
            <div className="z-index-master">
                <div className="card shadow opacity-modal">
                    <div className="card-header pb-0  d-flex justify-content-between">
                        <h5 className="card-header-title d-inline headers">{t("UPDATE_PASSWORD")}</h5>
                    </div>
                    <div className="card-body bg-white p-0">
                        <form onSubmit={handleSubmit(onSubmit)} className="card-body h-100 p-3">
                            <div className="mb-3">
                                <label className="labels">{t("CURRENT_PASSWORD")}:</label>
                                <div className="input-group">
                                    <input {...register("oldPassword", { required: t("ENTER_CURRENT_PASSWORD") })}
                                        className="form-control ps-0 b-none inputs inputs-modal"
                                        id="psw-input"
                                        type={passwordVisible ? "text" : "password"}
                                        placeholder={t("ENTER_CURRENT_PASSWORD")} />
                                </div>
                                {errors.oldPassword != undefined && <span className="text-danger">{errors.oldPassword.id ? t("OLD_PASSWORD_NOT_SAME") : t("ENTER_CURRENT_PASSWORD")}</span>}
                            </div>
                            <div className="mb-3">
                                <label className="labels">{t("NEW_PASSWORD")}:</label>
                                <div className="input-group">
                                    <input
                                        {...register("password", {
                                            required: t("PASSWORD_IS_REQUIRED"),
                                            pattern: {
                                                value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!.%*?&])[A-Za-z\d@$!.%*?&]{8,}$/
                                                ,
                                            }
                                        })}
                                        className="form-control ps-0 fakepassword b-none inputs inputs-modal"
                                        placeholder={t("ENTER_NEW_PASSWORD")}
                                        type={passwordVisible ? "text" : "password"} id="psw-input" />
                                    <span className="p-0 bg-transparent b-none">
                                        <i className={`fakepasswordicon fas ${passwordVisible ? "fa-eye" : "fa-eye-slash"} inputs cursor-pointer p-2`} onClick={toggleVisibility}></i>
                                    </span>
                                </div>
                                {errors.password && <span className="text-danger">{errors.password.id ? t("NEW_PASSWORD_SAME_AS_CURRENT") : t("ERROR_PASSWORD")}</span>}
                            </div>
                            <div>
                                <label className="labels">{t("CONFIRM_PASSWORD")}:</label>
                                <div className="input-group">
                                    <input {...register("password2", {
                                        required: t("ENTER_CONFIRM_PASSWORD"),
                                        pattern: {
                                            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!.%*?&])[A-Za-z\d@$!.%*?&]{8,}$/
                                        }
                                    })}
                                        id="psw-input"
                                        className="form-control ps-0 b-none inputs inputs-modal "
                                        type={passwordVisible ? "text" : "password"}
                                        placeholder={t("CONFIRM_PASSWORD2")} />
                                </div>
                                {errors.password2 && <span className="text-danger">{errors.password2.id ? t("NEW_PASSWORD_SAME_AS_CURRENT") : t("ENTER_CONFIRM_PASSWORD")}</span>}
                                {errors.password2NotSame && <span className="text-danger">{("CONFIRM_PASSWORD_NOT_SAME_AS_NEW_PASSWORD")}</span>}
                            </div>

                            <button disabled={isFormSubmitting} type="submit" className="btn btn-font btn-size btn-primary mt-4 me-1">
                                {isFormSubmitting && <i className="fa fa-spin fa-spinner"></i>}
                                {t("UPDATE_PASSWORD")}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </>

    )
});

export default UpdatePasswordModal;